"use client";

import { Dialog, DialogContent } from "@/components/ui/dialog";
import CreateAvatarWizard from "./createAvatarWizard/createAvatarWizard";

interface Props {
    open: boolean;
    onOpenChange: (open: boolean) => void;
}

export default function CreateAvatarModal({ open, onOpenChange }: Props) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-2xl" xPosition="top-1 end-1">
                <CreateAvatarWizard onClose={() => onOpenChange(false)} />
            </DialogContent>
        </Dialog>
    );
}
